/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { PanelContainer } from '@atlassian/panel-system';
import { PanelBodySkeleton } from '@atlassian/panel-system/panel-body-skeleton';
import { PanelContent } from '@atlassian/panel-system/panel-content';
import { PanelFooterSkeleton } from '@atlassian/panel-system/panel-footer-skeleton';
import { PanelHeaderSkeleton } from '@atlassian/panel-system/panel-header-skeleton';
import { PanelSubheaderSkeleton } from '@atlassian/panel-system/panel-subheader-skeleton';

// This width is only set so the panel renders at a sensible size in the docs.
// Please use the navigation-system panel slot to size panels — do not hardcode this.
// In a real panel, pass your custom skeleton to `PanelRouter`'s `fallback` prop.
const styles = cssMap({
	exampleWrapper: {
		width: '400px',
		height: '480px',
	},
});

export function LoadingComposable(): JSX.Element {
	return (
		<Box xcss={styles.exampleWrapper}>
			<PanelContainer testId="panel-container-skeleton">
				<PanelHeaderSkeleton shouldShowIcon actionsCount={3} />
				<PanelContent>
					<PanelSubheaderSkeleton shouldShowIcon />
					<PanelBodySkeleton />
				</PanelContent>
				<PanelFooterSkeleton actionsCount={2} />
			</PanelContainer>
		</Box>
	);
}

export default LoadingComposable;
